import axios from 'axios';
import { FileUploader, Form, LoadPanel, Menu, Popup } from 'devextreme-react';
import { ButtonItem, ButtonOptions, Label, RequiredRule } from 'devextreme-react/cjs/form';
import { Item } from 'devextreme-react/list';
import notify from 'devextreme/ui/notify';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import GlobalParams from '../../helpers/GlobalParams';
//import { default_form } from './Enquiries';

var default_form =
{
  scheme_id: null,
  isNew: true,
  Subject: null,
  Narration: '',
  Response: '',
};

export const EnquiriesForm = ({ open, onClose, title, vsEdit, MessageId, scheme_id, Subject, Response }) => {
  var filesData = [];

  const formDataRef = useRef(null);
  //const [Response, setResponse] = useState('');
  //const [Subject, setSubject] = useState('');
  //const [vsEdit, setVsEdit] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [enquiriesData, setEnquiriesData] = useState([]);
  // const [popupEnquiryVisible, setPopupEnquiryVisible] = useState(false);

  const [enquiryStore, setEnquiryStore] = useState(default_form);


  const emptyItemConfig = {
    colSpan: 3,
    itemType: 'empty',
  };

  const postEnquiries = async (post_data) => {
    try {
      console.log(post_data);
      let tmp_filesData = filesData || [];

      let has_attachment = 0;
      if (filesData.length > 0) {
        has_attachment = 1;
      }
      var combinedHashmap = {
        'scheme_id': post_data.scheme_id,
        'portal_user_id': GlobalParams.ContactPersonId,
        'Subject': post_data.Subject,
        'Narration': post_data.Narration,
        'has_attachment': has_attachment
      };
      let url = GlobalParams.ApiUrlPrefix + "submit-enquiry";
      if (vsEdit) {
        url = GlobalParams.ApiUrlPrefix + "reply-to-response";
        combinedHashmap = {
          'MessageId': MessageId,
          'ClientResponse': post_data.Narration
        };
      }
      let postData = combinedHashmap;
      var combinedHashmap = tmp_filesData.length > 0 ? tmp_filesData.reduce((acc, obj, index) => {
        // Assuming the formdata is the key 'key' in each object
        Object.keys(obj).forEach(key => {
          acc[`attachments[${key}]`] = obj[key];
        });
        return acc;
      }, { ...postData }) : postData;


      const result = await axios.post(
        url,
        combinedHashmap,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      console.log(result.status);
      setIsLoading(false);
      notify("Enquiry Successfully Sent", 'success', 5000);
      setIsLoading(true);
      fetchEnquiries(1);

    } catch (error) {
      // Handle error, e.g., show an error message
      setIsLoading(false);
      console.log(error);
      if (error.response != undefined) {
        notify(error.response.data.message, 'error', 5000);
      }
    }
  };

  const fetchEnquiries = async (fetch_type) => {
    try {
      const result = await axios.get(
        GlobalParams.ApiUrlPrefix + "enquiries-under-client?client_id=" + GlobalParams.ClientId + "&portal_user_id=" + GlobalParams.ContactPersonId,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
          }
        }
      );
      setIsLoading(false);
      setEnquiriesData(result.data.data);
      if (fetch_type === 1) {
        clear_form();
        onClose();
      }
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };


  const clear_form = () => {
    setEnquiryStore(default_form);
  };
  const doSend = useCallback(async (e) => {
    e.preventDefault();
    console.log('clicked');
    setIsLoading(true);
    postEnquiries(enquiryStore);
  }, [enquiryStore]);

  return (
    <div>
      <Popup style={{
        padding: 20,
      }}
        visible={open}
        title={title}
        dragEnabled={true}
        showCloseButton={true}
        hideOnOutsideClick={true}
        onHiding={onClose}
      >
        <div>
          {isLoading && <LoadPanel visible={true} />}
          <form onSubmit={doSend}>
            <Form formData={enquiryStore} ref={formDataRef}>
              <Item {...emptyItemConfig} />
              <Item {...emptyItemConfig} />

              {/* scheme_id */}
              <Item
                dataField="scheme_id"
                visible={!vsEdit}
                editorType="dxLookup"
                editorOptions={
                  {
                    dataSource: GlobalParams.schemeStore,
                    displayExpr: "PolicyCompany",
                    valueExpr: "schemeID",
                    searchEnabled: false,
                    onValueChanged: (e) => {
                      //fetch the categories at these point
                      if (e.value === '' || e.value === null || e.value === undefined) {
                        setEnquiryStore((state) => {
                          return ({ ...state, scheme_id: e.value })
                        });
                      }
                    }
                  }
                }
              >
                <RequiredRule message="Policy No / Scheme is required" />
                <Label text='Policy No / Scheme' />
              </Item>

              <Item
                dataField="response_scheme_id"
                visible={vsEdit}
                editorType="dxLookup"
                editorOptions={
                  {
                    readOnly: true,
                    dataSource: GlobalParams.schemeStore,
                    displayExpr: "PolicyCompany",
                    valueExpr: "schemeID",
                    searchEnabled: false,
                    value: scheme_id
                  }
                }
              >
                <RequiredRule message="Policy No / Scheme is required" />
                <Label text='Policy No / Scheme' />
              </Item>


              <Item
                dataField="Subject"
                visible={!vsEdit}
                editorType="dxLookup"
                editorOptions={
                  {
                    readOnly: false,
                    dataSource: GlobalParams.EnquiriesSubjects,
                    displayExpr: "Description",
                    valueExpr: "Id",
                    searchEnabled: false,
                    onValueChanged: (e) => {
                      if (!vsEdit) {
                        if (e.value === '' || e.value === null || e.value === undefined) {
                          setEnquiryStore((state) => {
                            return ({ ...state, Subject: e.value })
                          });
                        }
                      }
                    }
                  }
                }
              >
                <RequiredRule message="Subject is required" />
                <Label text='Subject' />
              </Item>

              <Item
                dataField="ResponseSubject"
                visible={vsEdit}
                editorType="dxLookup"
                editorOptions={
                  {
                    readOnly: true,
                    dataSource: GlobalParams.EnquiriesSubjects,
                    displayExpr: "Description",
                    valueExpr: "Id",
                    searchEnabled: false,
                    value: Subject
                  }
                }
              >
                <RequiredRule message="Subject is required" />
                <Label text='Subject' />
              </Item>

              <Item
                dataField="Response"
                visible={vsEdit}
                editorType="dxTextArea"
                editorOptions={
                  {
                    readOnly: true,
                    /*onValueChanged: (e) => {
                      if (e.value === '' || e.value === null || e.value === undefined) {
                        setEnquiryStore((state) => {
                          return ({ ...state, Response: e.value })
                        });
                      }
                    },*/
                    value: Response,
                  }
                }
              >
                <Label text={'Response'} />
              </Item>

              <Item
                dataField="Narration"
                editorType="dxTextArea"
                editorOptions={
                  {
                    readOnly: false,
                    onValueChanged: (e) => {
                      if (e.value === '' || e.value === null || e.value === undefined) {
                        setEnquiryStore((state) => {
                          return ({ ...state, Narration: e.value })
                        });
                      }
                    }
                  }
                }
              >
                <Label text={'Narration'} />
              </Item>


              {/* Upload any file */}
              <Item colSpan={3}>
                {/* <div style={{ color: '#2E86C1', fontWeight: 'bold', display: vsEdit ? 'none' : 'block' }}>Add Attachment</div> */}
                <FileUploader
                  // visible={!vsEdit}
                  visible={false}
                  multiple={false}
                  selectButtonText="Select File"
                  uploadMode="useForm"
                  onValueChanged={(e) => {
                    let files = e.value;
                    filesData.push({ [1]: files[0] });
                  }}
                  style={{ borderBottom: '1px solid #000' }}
                />
              </Item>

              <Item {...emptyItemConfig} />
              <Item {...emptyItemConfig} />

              <ButtonItem>
                <ButtonOptions type='danger' text="SEND" icon='message' useSubmitBehavior={true} />
              </ButtonItem>

            </Form>
          </form>
        </div>
      </Popup>
    </div>
  );
};
